import * as React from "react";

import { logout } from "../services/logout";
import { parseReturnToQueryParam } from "../utils/utils";
import { Loader } from "./Loader";

interface IProps {
  location: Location;
}

export class LogoutUI extends React.Component<IProps> {
  componentDidMount() {
    logout(parseReturnToQueryParam(this.props.location.search));
  }
  render() {
    return <Loader />;
  }
}
